import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { mainApiUrl as baseUrl, localApiUrl } from '@constants'
import { prepareHeaders, transformResponse } from '@src/reduxjs'

const mainApi = createApi({
  reducerPath: 'mainApi',
  baseQuery: fetchBaseQuery({ baseUrl, prepareHeaders }),
  tagTypes: [],
  endpoints: (builder) => ({
    getStoreImages: builder.query({
      query: () => `${localApiUrl}/images`,
      transformResponse,
    }),
    getStoreMedia: builder.query({
      query: () => `${localApiUrl}/media`,
      transformResponse,
    }),
    getStoreStatus: builder.query({
      query: () => `${localApiUrl}/status`,
      transformResponse,
    }),
    getStoreModules: builder.query({
      query: () => `${localApiUrl}/modules`,
      transformResponse,
    }),
  }),
})

export const { useGetStoreImagesQuery, useGetStoreMediaQuery, useGetStoreStatusQuery, useGetStoreModulesQuery } = mainApi

export default mainApi
